import { useQuery } from '@tanstack/react-query';
import { Scale } from 'lucide-react';
import { Link } from 'react-router-dom';
import { apiClient } from '@/lib/api-client';
import { cn } from '@/lib/utils';
import { CardShell, EmptyState } from './card-shell';

export function ProcessesOverviewCard() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['cases', 'stats', 'summary'],
    queryFn: () => apiClient.casesStatsSummary(),
    staleTime: 1000 * 60,
  });

  if (isLoading) {
    return (
      <CardShell title="Processos" icon={Scale}>
        <div className="flex w-full flex-col items-start gap-2">
          <div className="h-10 w-24 animate-pulse rounded bg-[var(--surface-muted)]" />
          <div className="h-3 w-32 animate-pulse rounded bg-[var(--surface-muted)]" />
        </div>
      </CardShell>
    );
  }

  if (isError) {
    return (
      <CardShell title="Processos" icon={Scale}>
        <p className="text-xs text-[var(--fg-muted)]">
          Não foi possível carregar.
        </p>
      </CardShell>
    );
  }

  const totalActive = data?.totalActive ?? 0;
  const total =
    totalActive +
    (data?.totalArchived ?? 0) +
    (data?.totalSuspended ?? 0) +
    (data?.totalClosed ?? 0);

  if (total === 0) {
    return (
      <CardShell title="Processos" icon={Scale}>
        <EmptyState
          icon={Scale}
          message="Nenhum processo cadastrado."
          cta={{ label: '+ Novo processo', href: '/escritorio/processos/novo' }}
        />
      </CardShell>
    );
  }

  return (
    <CardShell title="Processos" icon={Scale}>
      <div className="flex w-full flex-col items-start gap-2">
        <span className="tabular-nums text-3xl font-semibold tracking-tight text-[var(--fg)]">
          {totalActive}
        </span>
        <p className="text-[11px] text-[var(--fg-muted)]">
          Processos ativos {total !== totalActive ? `(${total} no total)` : ''}
        </p>
        <Link
          to="/escritorio/processos"
          className={cn(
            'mt-1 inline-flex items-center gap-1 rounded-md px-3 py-1.5 text-xs font-medium transition',
            'border border-[var(--border)] text-[var(--fg)] hover:bg-[var(--surface-muted)]',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]',
          )}
        >
          Ver todos
        </Link>
      </div>
    </CardShell>
  );
}
